import { AmplitudeEvent } from "@analytics/Amplitude/AmplitudeEvents";
import { AdditionalSourceData, UpgradeCTASource } from "@user/AmplitudeProSubsEvents";

enum UserEvent {
    USER_METRICS_INTERACT = "user_metrics_event",

    USER_AUTH_FLOW_START = "user_auth_flow_start",
    USER_SIGN_IN = "user_sign_in",
    USER_SIGN_UP = "user_sign_up",
    USER_LOGOUT = "user_logout",
    DISPLAY_SIGN_UP_CTA = "cta_user_sign_up",

    SHARE_REFERRAL_LINK = "share_referral_link",
}

export enum SignUpCTASource {
    USER_METRICS_MODAL = "USER METRICS MODAL",
    TOOLBAR = "TOOLBAR",
    CALENDAR_SIDEBAR = "CALENDAR_SIDEBAR",
    SPACES = "SPACES",
    ROOMS = "ROOMS",
    ROOM_CHAT = "ROOM_CHAT",
    SAVE_SPACE = "SAVE_SPACE",
    SAVED_SPACES_MENU = "SAVED_SPACES_MENU",
    POMODORO_SOUNDS = "POMODORO_SOUNDS",
    GROUP_POMODORO = "GROUP_POMODORO",
    /** deprecated */
    SPACE_SHUFFLES = "space_shuffles",
}

export type SignUpOrUpgradeSource = SignUpCTASource | UpgradeCTASource;

interface SignUpCtaSourceDetails {
    /**
     * Source of event
     */
    source: SignUpOrUpgradeSource;
    /**
     * Additional source data
     */
    additionalSourceData?: AdditionalSourceData;
}

export class StartUserAuthFlowEvent extends AmplitudeEvent {
    constructor() {
        super(UserEvent.USER_AUTH_FLOW_START);
    }
}

export class DisplayUserSignUpCtaEvent extends AmplitudeEvent {
    constructor(eventDetails: SignUpCtaSourceDetails) {
        super(UserEvent.DISPLAY_SIGN_UP_CTA);
        this.props = eventDetails;
    }
}

export class UserShareReferralLinkEvent extends AmplitudeEvent {
    constructor(referralCode: string) {
        super(UserEvent.SHARE_REFERRAL_LINK);
        this.props = { referralCode: referralCode };
    }
}

export class UserSignInEvent extends AmplitudeEvent {
    /* Records a user's sign-in status */
    constructor(isSuccessful: boolean, isNewUser?: boolean, isVerified?: boolean) {
        super(isNewUser ? UserEvent.USER_SIGN_UP : UserEvent.USER_SIGN_IN);
        this.props = { verified: isVerified };
    }
}

export class UserLogoutEvent extends AmplitudeEvent {
    constructor() {
        super(UserEvent.USER_LOGOUT);
    }
}

export class UserMetricsInteractEvent extends AmplitudeEvent {
    constructor() {
        super(UserEvent.USER_METRICS_INTERACT);
    }
}
